<template>
  <div>
    <input
      type="hidden"
      :name="filtername"
      :value="selectedSpecificationPropertyMasterDataId"     
    />

    <v-select :options="selections" label="title" v-model="selected"  @input="setSelected"></v-select>

  </div>
</template>
<script>
export default {
  props: {
    items: String,
    filterKey: String,
    specificationPropertyMasterDataId: String
  },
  data: () => ({
    selected: {},
    selectedSpecificationPropertyMasterDataId: ''
  }),
  created() {
    // console.log("items ", this.items);

    let result = this.selections.filter(obj => {
      return (
        obj.specificationPropertyMasterDataId ===
        this.specificationPropertyMasterDataId
      );
    });
    
    this.selected = result;
    this.selectedSpecificationPropertyMasterDataId = this.specificationPropertyMasterDataId;
  },
  methods: {
    setSelected(value) {
      this.selectedSpecificationPropertyMasterDataId = value.specificationPropertyMasterDataId;
    }
  },
  computed: {
    selections: function() {
      return JSON.parse(this.items);
    },
    filtername: function() {
      return "filters[" + this.filterKey + "]";
    }
  }
};
</script>